/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { ToastComponent } from "@syncfusion/ej2-react-notifications";
import { ChangeEventHandler, useEffect, useRef, useState } from "react";

import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function ClassificationSelector({
	name,
	defaultValue,
	disabled = false,
	handelSelect,
}: {
	name: string;
	defaultValue: string;
	disabled: boolean;
	handelSelect: ChangeEventHandler;
}) {
	return (
		<select name={name} defaultValue={defaultValue} disabled={disabled} onChange={handelSelect}>
			<option value="0"></option>
			<option value="1">ANIMALES VIVOS Y PRODUCTOS DEL REINO ANIMAL</option>

			<option value="2">PRODUCTOS DEL REINO VEGETAL</option>

			<option value="3">
				GRASAS Y ACEITES ANIMALES O VEGETALES; PRODUCTOS DE SU DESDOBLAMIENTO; GRASAS ALIMENTICIAS
				ELABORADAS; CERAS DE ORIGEN ANIMAL O VEGETAL
			</option>

			<option value="4">
				PRODUCTOS DE LAS INDUSTRIAS ALIMENTARIAS; BEBIDAS, LÍQUIDOS ALCOHÓLICOS Y VINAGRE; TABACO Y
				SUCEDÁNEOS DEL TABACO ELABORADOS
			</option>

			<option value="5">PRODUCTOS MINERALES</option>

			<option value="6">PLÁSTICO Y SUS MANUFACTURAS; CAUCHO Y SUS MANUFACTURAS</option>

			<option value="7">PRODUCTOS DE LAS INDUSTRIAS QUÍMICAS O DE LAS INDUSTRIAS CONEXAS</option>

			<option value="8">
				PIELES, CUEROS, PELETERÍA Y MANUFACTURAS DE ESTAS MATERIAS; ARTÍCULOS DE TALABARTERÍA O
				GUARNICIONERÍA; ARTÍCULOS DE VIAJE, BOLSOS DE MANO (CARTERAS)
			</option>

			<option value="9">Y CONTINENTES SIMILARES; MANUFACTURAS DE TRIPA</option>

			<option value="10">
				MADERA, CARBÓN VEGETAL Y MANUFACTURAS DE MADERA; CORCHO Y SUS MANUFACTURAS; MANUFACTURAS DE
				ESPARTERÍA O CESTERÍA
			</option>

			<option value="11">
				PASTA DE MADERA O DE LAS DEMÁS MATERIAS FIBROSAS CELULÓSICAS; PAPEL O CARTÓN PARA RECICLAR
				(DESPERDICIOS Y DESECHOS); PAPEL O CARTÓN Y SUS APLICACIONES
			</option>

			<option value="12">MATERIAS TEXTILES Y SUS MANUFACTURAS</option>

			<option value="13">
				CALZADO, SOMBREROS Y DEMÁS TOCADOS, PARAGUAS, QUITASOLES, BASTONES, LÁTIGOS, FUSTAS, Y SUS
				PARTES; PLUMAS PREPARADAS Y ARTÍCULOS DE PLUMAS; FLORES ARTIFICIALES; MANUFACTURAS DE
				CABELLO
			</option>

			<option value="14">
				MANUFACTURAS DE PIEDRA, YESO FRAGUABLE, CEMENTO, AMIANTO (ASBESTO), MICA O MATERIAS
				ANÁLOGAS; PRODUCTOS CERÁMICOS; VIDRIO Y SUS MANUFACTURAS
			</option>

			<option value="15">
				PERLAS FINAS (NATURALES)* O CULTIVADAS, PIEDRAS PRECIOSAS O SEMIPRECIOSAS, METALES
				PRECIOSOS, CHAPADOS DE METAL PRECIOSO (PLAQUÉ) Y MANUFACTURAS DE ESTAS MATERIAS; BISUTERÍA;
				MONEDAS
			</option>

			<option value="16">METALES COMUNES Y MANUFACTURAS DE ESTOS METALES</option>

			<option value="17">
				MÁQUINAS Y APARATOS, MATERIAL ELÉCTRICO Y SUS PARTES; APARATOS DE GRABACIÓN O REPRODUCCIÓN
				DE SONIDO, APARATOS DE GRABACIÓN O REPRODUCCIÓN DE IMAGEN Y SONIDO EN TELEVISIÓN, Y LAS
				PARTES Y ACCESORIOS DE ESTOS APARATOS
			</option>

			<option value="18">MATERIAL DE TRANSPORTE</option>

			<option value="19">
				INSTRUMENTOS Y APARATOS DE ÓPTICA, FOTOGRAFÍA O CINEMATOGRAFÍA, DE MEDIDA, CONTROL O
				PRECISIÓN; INSTRUMENTOS Y APARATOS MEDICOQUIRÚRGICOS; APARATOS DE RELOJERÍA; INSTRUMENTOS
				MUSICALES; PARTES Y ACCESORIOS DE ESTOS INSTRUMENTOS O APARATOS
			</option>

			<option value="20">ARMAS, MUNICIONES, Y SUS PARTES Y ACCESORIOS</option>

			<option value="21">MERCANCÍAS Y PRODUCTOS DIVERSOS</option>

			<option value="22">OBJETOS DE ARTE O COLECCIÓN Y ANTIGÜEDADES</option>
		</select>
	);
}

function Table({
	classification,
	setClassification,
}: {
	classification: { id: number; value: string }[];
	setClassification: React.Dispatch<React.SetStateAction<{ id: number; value: string }[]>>;
}) {
	const [showRowForm, setShowRowForm] = useState(false);
	const [editingRowId, setEditingRowId] = useState(0);
	const [newClassification, setNewClassification] = useState({ id: -1, value: "0" });

	const toastInstance = useRef<ToastComponent>(null);

	function toastCreated() {
		toastInstance.current.show();
	}

	function handleNewClassification(event: React.ChangeEvent<HTMLInputElement>) {
		setNewClassification({ id: Math.floor(Math.random() * 10000), value: event.target.value });
	}

	function handleEditClassification(event: React.ChangeEvent<HTMLInputElement>) {
		setNewClassification({ id: editingRowId, value: event.target.value });
	}

	function handleClickShowAddRow() {
		if (showRowForm) {
			setShowRowForm(false);
			setNewClassification({ id: -1, value: "0" });
		} else {
			setShowRowForm(true);
		}
	}

	function handleClickSaveRow() {
		if (newClassification.value === "0") {
			toastCreated();
			//alert("Seleccione una categoria");

			return;
		}

		if (editingRowId === 0) {
			setClassification([
				...classification.filter((e) => e.value !== newClassification.value),
				newClassification,
			]);
		} else {
			setClassification([
				...classification
					.filter((e) => e.value !== newClassification.value)
					.filter((e) => e.id !== editingRowId),
				newClassification,
			]);
		}

		setShowRowForm(false);
		setEditingRowId(0);
		setNewClassification({ id: -1, value: "0" });
	}

	function handleClickCancelRow() {
		setShowRowForm(false);
		setEditingRowId(0);
		setNewClassification({ id: -1, value: "0" });
	}

	function handleClickEditRow(category: { id: number; value: string }) {
		setEditingRowId(category.id);
		setNewClassification(category);
	}

	function handleClickDeleteRow(categoryId: number) {
		setClassification(classification.filter((e) => e.id !== categoryId));
	}

	//ver Selector fuera de edicion
	return (
		<>
			<ToastComponent
				ref={toastInstance}
				title="Error!"
				content="Seleccione una categoria"
				cssClass="e-toast-danger"
				icon="e-error toast-icons"
			/>
			<table>
				<thead>
					<tr>
						<th>
							<a
								href="https://www.mercosur.int/politica-comercial/ncm/"
								target="_blank"
								rel="noreferrer"
							>
								Acceso a la nomenclatura común del Mercosur
							</a>
						</th>
						<th>
							{classification.length < 22 && (
								<button
									//className="btn-small"
									type="button"
									disabled={Boolean(editingRowId) || showRowForm}
									onClick={handleClickShowAddRow}
								>
									Agregar
								</button>
							)}
						</th>
					</tr>
				</thead>
				<tbody>
					{showRowForm && (
						<>
							<tr>
								<th>Categorías</th>
								<th></th>
							</tr>
							<tr>
								<td>
									<ClassificationSelector
										name="newClassification"
										defaultValue="0"
										disabled={false}
										handelSelect={handleNewClassification}
									/>
								</td>
								<td>
									<div className="actionButtonsWrapper">
										<button className="btn-small" type="button" onClick={handleClickSaveRow}>
											Guardar
										</button>
										<button className="btn-small" type="button" onClick={handleClickCancelRow}>
											Cancelar
										</button>
									</div>
								</td>
							</tr>
						</>
					)}
					{classification.map((d) => {
						return editingRowId === d.id ? (
							<tr key={d.id}>
								<td>
									<ClassificationSelector
										name="newClassification"
										defaultValue={d.value}
										disabled={false}
										handelSelect={handleEditClassification}
									/>
								</td>
								<td>
									<div className="actionButtonsWrapper">
										<button className="btn-small" type="button" onClick={handleClickSaveRow}>
											Guardar
										</button>
										<button className="btn-small" type="button" onClick={handleClickCancelRow}>
											Cancelar
										</button>
									</div>
								</td>
							</tr>
						) : (
							<tr key={d.id}>
								<td>
									<ClassificationSelector
										name={`classification${d.value}`}
										defaultValue={d.value}
										disabled={true}
									/>
								</td>

								<td className="tdActionButtonsWrapper">
									<div className="actionButtonsWrapper">
										<button
											className="btn-small"
											type="button"
											disabled={Boolean(editingRowId) || showRowForm}
											onClick={() => handleClickEditRow(d)}
										>
											Editar
										</button>
										<button
											className="btn-small"
											type="button"
											disabled={Boolean(editingRowId) || showRowForm}
											onClick={() => handleClickDeleteRow(d.id)}
										>
											Borrar
										</button>
									</div>
								</td>
							</tr>
						);
					})}
				</tbody>
			</table>
		</>
	);
}

function CommonClassification() {
	const { currentStep, countryBrandApplication, update, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const { commonClassification } = countryBrandApplication;

	const [classification, setClassification] = useState([]);

	useEffect(() => {
		setClassification(
			commonClassification.map((e) => {
				return { id: Math.floor(Math.random() * 10000), value: e };
			})
		);
	}, []);

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			const commonClassification = classification.map((e) => {
				return e.value;
			});

			update({
				data: {
					commonClassification,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [classification]);

	return (
		<div className="step-page" id="step-7">
			<section>
				<h3>7 - Nomenclatura (NMC)</h3>
				<Table classification={classification} setClassification={setClassification} />
			</section>
		</div>
	);
}

export { CommonClassification };
